import { Box, Button, Grid, TextField } from '@material-ui/core'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  manageLoader,
  queryByName,
  queryByName2,
  relocateUser,
  selectQueryResult,
  selectQueryResult2
} from './state/manageSlice'
import { userProfile } from '@views/profile/state/profileSlice'
import { Role, User } from '@types'

const ManageView: React.FC = () => {
  const [searchKey, setSearchKey] = useState<string>('')
  const [searchKey2, setSearchKey2] = useState<string>('')
  const [itemSelected, setItemSelected] = useState<User | undefined>()
  const { role } = useSelector(userProfile)
  const { count, result } = useSelector(selectQueryResult)
  const { count2, result2 } = useSelector(selectQueryResult2)
  const { isLoading, isLoading2 } = useSelector(manageLoader)
  const dispatch = useDispatch()
  const searchByName = (e: any) => {
    e.preventDefault()
    dispatch(queryByName(searchKey))
  }
  const searchByName2 = (e: any) => {
    e.preventDefault()
    dispatch(queryByName2(searchKey2))
  }

  const handleSelectParent = (newParent: User, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault()
    if (!!newParent._id) {
      console.error('No hay id de newParent')
    }
    if (confirm(`Quieres colocar al usuario ${itemSelected?.name} debajo de ${newParent.name}`)) {
      dispatch(
        relocateUser({
          user: itemSelected as User,
          newParentId: newParent._id || ''
        })
      )
    }
  }

  if (role === Role.admin)
    return (
      <div className="center_view padding_view">
        <Grid container>
          <Grid item xs={6}>
            <form onSubmit={searchByName} style={{ width: '100%' }}>
              <Box display="flex" justifyContent="space-around" marginBottom="1.5em">
                <TextField
                  label="Ahorrador"
                  value={searchKey}
                  onChange={event => setSearchKey(event.target.value)}
                  variant="outlined"
                />
                <Button type="submit" variant="contained" color="primary">
                  Buscar
                </Button>
              </Box>
            </form>
            {isLoading ? (
              <>loader</>
            ) : itemSelected?._id ? (
              <Box
                display="flex"
                justifyContent="space-between"
                margin="1em"
                padding="1em"
                border="1px solid #e3e3e3"
                boxSizing="border-box"
              >
                {itemSelected?.name}
                <Button variant="contained" color="primary" onClick={() => setItemSelected(undefined)}>
                  Cancelar
                </Button>
              </Box>
            ) : (
              count > 0 &&
              result.map(item => (
                <Box
                  key={item._id}
                  display="flex"
                  justifyContent="space-between"
                  margin="1em"
                  padding="1em"
                  border="1px solid #e3e3e3"
                  boxSizing="border-box"
                >
                  {item.name}
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={itemSelected === item}
                    onClick={() => setItemSelected(item)}
                  >
                    Seleccionar
                  </Button>
                </Box>
              ))
            )}
          </Grid>
          <Grid item xs={6}>
            <form onSubmit={searchByName2} style={{ width: '100%' }}>
              <Box display="flex" justifyContent="space-around" marginBottom="1.5em">
                <TextField
                  label="Referenciador"
                  value={searchKey2}
                  disabled={!itemSelected?._id}
                  onChange={event => setSearchKey2(event.target.value)}
                  variant="outlined"
                />
                <Button type="submit" variant="contained" color="primary">
                  Buscar
                </Button>
              </Box>
            </form>
            {isLoading2 ? (
              <>loader</>
            ) : (
              count2 > 0 &&
              result2.map(item => (
                <Box
                  key={item._id}
                  display="flex"
                  justifyContent="space-between"
                  margin="1em"
                  padding="1em"
                  border="1px solid #e3e3e3"
                  boxSizing="border-box"
                >
                  {item.name}
                  <Button variant="contained" color="primary" onClick={e => handleSelectParent(item, e)}>
                    Seleccionar
                  </Button>
                </Box>
              ))
            )}
          </Grid>
        </Grid>
      </div>
    )
  else return <>No cuentas con los permisos necesarios para acceder a este sitio</>
}

export default ManageView
